import { render, staticRenderFns } from "./DocumentGrid.vue?vue&type=template&id=0384ecc6&scoped=true&"
import script from "./DocumentGrid.vue?vue&type=script&lang=js&"
export * from "./DocumentGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384ecc6",
  null
  
)

export default component.exports